module.exports = __webpack_public_path__ + "static/media/paysafe-logo.d28d1a57.svg";